import React from 'react';
import '../../styles/Container.css';

const Container = ({ 
  children, 
  className = '', 
  fluid = false,
  centered = false,
  padding = true,
  ...rest 
}) => {
  return (
    <div 
      className={`
        container 
        ${fluid ? 'fluid' : ''} 
        ${centered ? 'centered' : ''} 
        ${padding ? '' : 'no-padding'} 
        ${className}
      `}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Container;